<template>
	<div>
		<div class="content">
			<div class="tsfx">
				<div class=" u-text-center title">精选IP形象</div>
				<div class=" u-text-center title_tips">热门专辑精选，每日都有新灵感</div>
				<div class="xxtj">
					<div class="lf">
						<div class="tp">
							<el-image v-if="iplistTop" fit="cover" :src="iplistTop.pictures.split(',')[0]"
								@click="toIp(iplistTop.ipId)" />
							<div class="tpcon" v-for="(item,index) in diaestList" :key="index"
								:style="{'display':index != showNum ?'none':'block'}">
								<h3 class="h3s">{{item.content}}</h3>
								<div class="tpft">
									<div class="tpz">
										<span>转自{{item.provenance}}</span>
									</div>
									<div>
										<i class="tp-icon el-icon-back" @click="leftClick"></i>
										<i class="tp-icon el-icon-right" @click="rightClick"></i>
									</div>
								</div>
							</div>
						</div>
						<div class="tb" v-if="iplistBottom">
							<div class="tbcon" v-for="(item,index) in iplistBottom" :key="index" @click="toIp(item)">
								<el-image fit="cover" :src="item.pictures.split(',')[0]" />
								<div class="tbname">{{item.name}}</div>
							</div>
						</div>
					</div>
					<div class="rh" v-if="workList.length !=0">
						<div class="rt">相关推荐</div>
						<div class="rhlist listHover" v-for="(item,index) in workList " :key="index"
							@click="toDetails(item)">
							<div class="limg">
								<el-image fit="cover" :src="item.picture" />
							</div>
							<div class="rhlistrh">
								<div class="h3">{{item.title}}</div>
								<div class="rhtips">
									<span v-for="(tag,ts) in item.tags.split(',').slice(0,3)" :key="ts">#{{tag}}</span>
								</div>
								<div class="rhname">
									<el-image fit="cover" :src="item.userAvatar" />
									<span>{{item.userName}}</span>
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		name: 'appearance',
		components: {},
		data() {
			return {
				iplistBottom: [],
				iplistTop: null,
				diaestList: [],
				workList: [],
				showNum: 0
			};
		},
		created() {
			this.getlist()

		},
		methods: {
			async getlist() {
				let params = {
					isTop: 0,
					pageNum: 1,
					pageSize: 3
				}
				const res = await this.$axios.get('/front/listIp', params)
				if (res.rows.length != 0) {
					this.iplistTop = res.rows[0]
					this.iplistBottom = res.rows.slice(1)
					this.getIpDigst(this.iplistTop.ipId)
					this.getWork(this.iplistTop.ipId)
				}
			},
			//去探索
			toIp(item) {
				const {
					href
				} = this.$router.resolve({
					name: "discovery",
					params: {
						ipId: item.ipId
					}
				})
				window.open(href, '_blank')
			},
			//作品详情
			toDetails(item) {
				const {
					href
				} = this.$router.resolve({
					path: "workdetails",
					query: {
						workId: item.workId,
					}
				})
				window.open(href, '_blank')
			},
			async getIpDigst(ipId) {
				let params = {
					pageNum: 1,
					pageSize: 10,
					ipId: ipId
				}
				const res = await this.$axios.get('/front/listIpDigest', params)
				this.diaestList = res.rows
			},
			async getWork(ipId) {
				let params = {
					pageNum: 1,
					pageSize: 5,
					ipId: ipId,
					isTop: 0
				}
				const res = await this.$axios.get('/front/listWorks', params)
				this.workList = res.rows
			},
			leftClick() {
				this.showNum--
				if (this.showNum < 0) this.showNum = this.diaestList.length - 1
			},
			rightClick() {
				this.showNum++
				if (this.showNum >= this.diaestList.length) this.showNum = 0
			}
		}
	}
</script>
<style lang="scss" scoped>
	//形象推荐
	.tsfx {
		padding: 100px 0 80px 0;
	}

	.xxtj {
		margin-top: 60px;
		display: flex;
		justify-content: space-between;

		.lf {
			flex: 1;
			margin-right: 20px;

			.tp {
				position: relative;
				cursor: pointer;
				overflow: hidden;
				border-radius: 4px;
				user-select: none;

				.el-image {
					width: 100%;
					height: 440px;
				}

				.tpcon {
					position: absolute;
					left: 0;
					right: 0;
					bottom: 0;
					line-height: 24px;
					transition-duration: .3s;
					padding: 14px 20px;
					background-image: linear-gradient(rgba(0, 0, 0, .2), rgba(0, 0, 0, .8));
					color: var(--white);

					.h3s {
						font-weight: normal;
						display: none;
						color: var(--white);
						transition-duration: .3s;
						font-size: 16px;
						overflow: hidden;
						margin-bottom: 10px;
					}

					.tips {
						span {
							color: var(--info);
							margin-right: 10px;
						}
					}

					.tpft {
						display: flex;
						justify-content: space-between;
						align-items: center;

						.tpz {
							display: flex;
							align-items: center;
							font-weight: bold;
							font-size: 16px;
						}

						.tp-icon {
							cursor: pointer;
							font-size: 20px;
							margin: 4px;

							&:hover {
								color: var(--brand);
							}
						}
					}
				}

				&:hover .h3s {
					display: block;
				}
			}

			.tb {
				margin-top: 20px;
				display: flex;
				justify-content: space-between;

				.tbcon:first-child {
					margin-right: 20px;
				}

				.tbcon {
					flex: 1;
					cursor: pointer;
					position: relative;
					overflow: hidden;
					border-radius: 4px;

					.el-image {
						width: 100%;
						height: 240px;
					}

					.tbname {
						position: absolute;
						left: 0;
						right: 0;
						bottom: -60px;
						transition-duration: .4s;
						background-color: rgba(255, 255, 255, .7);
						padding: 14px 20px;
						line-height: 20px;
						height: 20px;
						font-weight: bold;
					}

					&:hover .tbname {
						bottom: 0;
					}
				}
			}
		}

		.rh {
			width: 450px;
			background-color: var(--white);

			.rt {
				background-color: var(--brand);
				padding: 14px 20px;
				font-size: 16px;
				line-height: 24px;
				color: var(--white);
			}

			.rhlist {

				&:hover .h3 {
					color: var(--brand);
				}

				box-shadow:none;
				cursor: pointer;
				margin: 20px;
				display: flex;
				justify-content: space-between;

				.limg {
					flex: 1;
					height: 105px;

					.el-image {
						width: 100%;
						height: 100%;
						border-radius: 4px;
					}
				}

				.rhlistrh {
					margin-left: 20px;
					width: 248px;

					.h3 {
						font-weight: bold;
						white-space: nowrap;
						text-overflow: ellipsis;
						overflow: hidden;
						font-size: 16px;
						color: var(--black);
					}

					.rhtips {
						color: var(--info);
						margin-top: 4px;

						span {
							margin-right: 10px;
							display: inline-block;
						}
					}

					.rhname {
						display: flex;
						align-items: center;
						margin-top: 10px;

						.el-image {
							width: 28px;
							height: 28px;
							margin-right: 10px;
							border-radius: 30px;
						}
					}
				}
			}
		}
	}
</style>
